"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _TestHelpers = require("./TestHelpers");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * For tests, this will be wrapped around each list of rendered components resulting from a
 * call to `find`.  This allows for exposing additional test helping code.
 * @module Wrapper
 */
var ArrayWrapper = /*#__PURE__*/function () {
  function ArrayWrapper() {
    var results = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    _classCallCheck(this, ArrayWrapper);

    this.component = {
      props: {}
    };

    if (Array.isArray(results)) {
      this.tree = results;
    } else {
      this.tree = [results];
    }

    this.isArray = true;
    this.length = this.tree.length;
  }
  /**
   * Will search the rendered tree for a tag name or a component name.
   * @function
   * @param {Component|string} elementOrComponent A String DOM name or Component
   * @return {ArrayWrapper} A wrapper containing the results of the search.
   */


  _createClass(ArrayWrapper, [{
    key: "find",
    value: function find(elementOrComponent) {
      return new ArrayWrapper((0, _TestHelpers.findNodes)(elementOrComponent, this));
    }
    /**
     * Will find all text in the tree and return a flattened version of it.
     * @function
     * @return {string} All of the text contained in the tree
     */

  }, {
    key: "text",
    value: function text() {
      return (0, _TestHelpers.flattenText)(this);
    }
    /**
     * Returns the first item in the tree
     * @function
     * @return {Wrapper|null} A component Test Wrapper, null if none
     */

  }, {
    key: "first",
    value: function first() {
      return this.at(0);
    }
    /**
     * Returns the last item in the tree
     * @function
     * @return {Wrapper|null} A component Test Wrapper, null if none
     */

  }, {
    key: "last",
    value: function last() {
      return this.at(this.length - 1);
    }
    /**
     * Returns the item at the specified index in the tree
     * @function
     * @param {number} index The index to pull from
     * @return {Wrapper|null} A component Test Wrapper, null if not found
     */

  }, {
    key: "at",
    value: function at(index) {
      if (index >= 0 && index <= this.length - 1) {
        return this.tree[index];
      }

      return null;
    }
  }]);

  return ArrayWrapper;
}();

exports["default"] = ArrayWrapper;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@harvest-profit/doc-flux/dist/TestArrayWrapper.js
// module id = 48
// module chunks = 0